import { ModalHeaderRow } from '@components/modal/ModalHeaderRow';
import { Text } from '@endurancewarranty/ui';

import type { FC } from 'react';

type Props = Readonly<{
  subtitle?: string;
  title: string;
}>;

export const ModalHeader: FC<Props> = ({ subtitle, title }) => {
  return (
    <ModalHeaderRow>
      <Text.Body size="lg" fontWeight="bold">
        {title}
      </Text.Body>
      {subtitle != null && (
        <Text.Body color={300} margin="mb-4">
          {subtitle}
        </Text.Body>
      )}
    </ModalHeaderRow>
  );
};
